

import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import stores from "@/store/store";
const store: any = stores;
import { BASE_API_URL } from "@/config";
import { mixins } from "vue-class-component";
import { HollowDotsSpinner } from "epic-spinners";
import DisplayFiles from "@/views/DisplayDocument.vue";
import { BROKER_LOAN_DOCUMENTS_EXTENSION, LOAN_TERM, ALLOWED_FILE_EXTENSIONS } from "@/constants";
import UpdateUserInfo from "@/views/UpdateUserInfo.vue";
import { DTIRadialBar } from "@/views/charts/radial-bar/dti-radial-bar";
import { loanInfo } from "@/models/borrowerData.model";
import SelectBorrowerForPos from "@/views/SelectBorrowerForPos.vue";
import CustomVueNumeric from "@/views/CustomVueNumeric.vue";
import LosRequiredField from "@/views/LosRequiredField.vue";
import DtiAndHousingRatioDetails from "@/views/DtiAndHousingRatioDetails.vue";
import LOSMixin from "@/mixins/los.mixin";
let  w = window as any;
const Vuebar = w.Vuebar as any;
Vue.use(Vuebar);;

@Component({
  components: {
    HollowDotsSpinner,
    DisplayFiles,
    Vuebar,
    UpdateUserInfo,
    SelectBorrowerForPos,
    CustomVueNumeric,
    DtiAndHousingRatioDetails,
    LosRequiredField
  }
})
export default class LoanDocuments extends mixins(LOSMixin) {
  public allowedFileExtensions = ALLOWED_FILE_EXTENSIONS;
  public RadialBar: DTIRadialBar;
  public loanInformation: any = new loanInfo();
  public loanTerm = LOAN_TERM;
  public validateDoc: any = {};
  public countUploadedIncomeDoc: number = null;
  public callOnSubmitToLoan = false;
  public isMailSent = false;
  public source = null;
  public personalInfo = [];
  public docExtension: any = BROKER_LOAN_DOCUMENTS_EXTENSION;
  public loanTxnId = null;
  public documentId = null;
  public doc = null;
  public docsToUpload = [];
  public borrowerDetails: any = null;
  public documents: any = [];
  public areDocumentsLoaded: boolean = false;
  public filesForSlide: any = [];
  public fileToDisplay = null;
  public displayFileType = null;
  public displayingFileSubCategoryName = null;
  public displayingFileIndex = 0;
  public confirmDeleteFile: any = null;
  public newSubCategory = null;
  public isNewSubCatEmpty = false;
  public isNewCategoryEmpty = false;
  public newCategory = null;
  public isCategoryFixed = false;
  public checkDocumentExt = false;
  public docFiles: any = null;
  public docId = null;
  public docComment = null;
  public docStatus = null;
  public errorInComment = false;
  public hasAppraisal = false;
  public isActiveOrderTitle = false;
  public hasLessThanLoanAmount = false;
  public hasGreaterRate = false;
  public isDelete = false;
  public isSubmit = false;
  public brokerProfilePicture = null;
  public orderTitleRequest: any = {
    companyName: "",
    email: "",
    phone: "",
    address: "",
    uploadedOn: new Date()
  };
  public loader1: any = [];
  public loader2: any = [];
  public loader3: any = [];
  public loader4: any = [];
  public loader5: any = [];
  public errorMsg = false;
  public warningClearedToSubmit: boolean = false;
  public isMandatoryBrokerOnboarding: boolean = false;
  //================================================================================================
  public hideSubmit: boolean = null;
  public dashboardOnboarding: boolean = null;
  //================================================================================================
  public taskOption = null;
  public notVoeNumber = false;
  public errorComment = false;
  public showButton = false;
  public checkDocHasUploaded = true;
  public comment = null;
  public moveToLead: boolean = true;
  public hasSubjectProperty = true;
  //Variables for all the storing all the error of empty field of 1003.
  public errorMessage =
    "Upload any three documents and Credit Card Authorization";
  public borrowerData: any = null;
  /** selection of Borrower for POS */
  // public openBorrowerSelectionModal = false;

  public losRequiredList = null;
  public isLosFieldMissing = false;
  public urlSource: string = null;
  public isEmailVerified = false;
  public dtiAndHousingRatioDetails: any = null;
  public currentEnvironment = null;
  
  /****************************************************************************************************************************
   *fetch (borrowerInfo collection personalInfo object for all borrower's , loanAndProperty collection propertyAddress object)*
   *                                and (DTI Ratio, HousingRatio)                                                             *
   ****************************************************************************************************************************/

  public ShowDtiValue = false;

  public async fetchBorrwoerInfo() {
    try {
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "loan/getBorrowerInfo",
        { loanTxnId: this.loanTxnId }
      );

      if (response.status == 200) {
        this.borrowerData = response.data;
      }
      
      this.isEmailVerified = this.borrowerData.isEmailVerified; //Checking borrower isEmailVerified.
      if (this.hasEdit()) {
        this.RadialBar = new DTIRadialBar(
          this.borrowerData.dtiRatio,
          this.borrowerData.housingRatio,
          "radialBar"
        );
      }
      this.urlSource = this.borrowerData.source;
      this.moveToLead = response.data.moveToLead;
      this.$store.state.wemloLoader = false;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  public updateBorrowerInfo(updatedData) {
    updatedData.forEach((element, index) => {
      this.borrowerData.borrowerInfo[index].contactInformation.email =
        element.email;
      this.borrowerData.borrowerInfo[index].contactInformation.cellPhone =
        element.cellPhone;
      this.borrowerData.borrowerInfo[index].name.firstName = element.firstName;
      this.borrowerData.borrowerInfo[index].name.lastName = element.lastName;
    });
  }

  public async updateBorrowerInfoData(data) {
    this.borrowerData.borrowerInfo[0].contactInformation.email =
      data.borrowerInfo[0].personalInfo.contactInformation.email;
    this.borrowerData.borrowerInfo[0].contactInformation.cellPhone =
      data.borrowerInfo[0].personalInfo.contactInformation.cellPhone;
    this.borrowerData.borrowerInfo[0].name.firstName =
      data.borrowerInfo[0].personalInfo.name.firstName;
    this.borrowerData.borrowerInfo[0].name.lastName =
      data.borrowerInfo[0].personalInfo.name.lastName;
  }
  /*************************************************************************************************************************
   *                              In that we get Co- name for Borrower                                             *
   *                               Used only for Primary Borrower(zero index).                                             *
   *************************************************************************************************************************/
  public getCoBorrower() {
    try {
      let mapping = this.borrowerDetails.relationshipMapping.find(
        a => a.borrowerIndex == this.borrowerDetails.primaryBorrowerIndex
      );
      if (mapping) {
        if (mapping.coBorrowerIndex.length > 0) {
          let firstName = this.borrowerData.borrowerInfo[
            mapping.coBorrowerIndex[0]
          ].name.firstName;
          let lastName = this.borrowerData.borrowerInfo[
            mapping.coBorrowerIndex[0]
          ].name.lastName;
          return firstName + " " + lastName;
        }
      }
      return "-";
    } catch (error) {
      console.log(error);
    }
  }

  public async showPersonalDetailModal(modalName) {
    try {
      this.personalInfo = [];
      this.borrowerData.borrowerInfo.forEach(borrower => {
        let data = {
          email: borrower.contactInformation.email,
          userId: borrower.userId,
          loanTxnId: this.loanTxnId,
          cellPhone: borrower.contactInformation.cellPhone,
          firstName: borrower.name.firstName,
          lastName: borrower.name.lastName,
          userType: "Borrower",
          modalName: modalName
        };
        this.personalInfo.push(data);
      });

      this.$refs.updateUserStatus["openModalOrClose"](this.personalInfo);
    } catch (error) {}
  }

  /**************************************************************************************************
   *                     When Click on the {Send Invite} button                                     *
   **************************************************************************************************/
  public async sendBorrowerPortal() {
    try {
      let hasMailSent = false;
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "borrower/getCheckBoxInfo",
        {
          loanTxnId: this.loanTxnId
        });
      if (response.data.msg == "success") {
        hasMailSent = true;
        this.isMailSent = true;
        this.$store.state.wemloLoader = false;
        this.$snotify.success("Invitation Sent successfully");
      } else {
        this.$store.state.wemloLoader = false;
        this.$snotify.error("Invitation Not Sent, Please try again");
      }
      // await this.getBorrowersDocumentsDetails();
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  public async deleteLoan() {
    try {
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "loan/deleteLoan",
        { loanTxnId: this.loanTxnId });
      this.$snotify.success(response.data.message);
      this.$router.push({ path: this.$getCurrentUserTypePath("dashboard") });
      this.$store.state.wemloLoader = false;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  public async getBrokerDetails() {
    try {
      this.$store.state.wemloLoader = true;
      let response = await Axios.get(BASE_API_URL + "broker/getBrokerDetails", {
        params: { brokerId: this.$brokerId }
      });
      this.brokerProfilePicture = response.data.brokerDetail.profilePicture;
      this.warningClearedToSubmit = this.isMandatoryBrokerOnboarding ? (!response.data.brokerDetail.clearedToSubmit || false) : false;
      this.$store.state.wemloLoader = false;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error.response);
    }
  }

  public async getPreQualLetter() {
    try {
      if (
        this.borrowerDetails &&
        this.borrowerDetails.loanInformation.propertyValue != 0
      ) {
        if (this.brokerProfilePicture != null) {
          this.$router.push({
            path: this.$getCurrentUserTypePath("pre-qualification"),
            query: { loanTxnId: this.loanTxnId }
          });
        } else {
          this.$snotify.info("Please upload logo to generate Pre-Qual letter");
        }
      } else {
        this.$snotify.info("Price is required");
      }
    } catch (error) {
      console.log(error);
    }
  }

  public async getBorrowersDocumentsDetails() {
    this.areDocumentsLoaded = false;
    try {
      this.$store.state.wemloLoader = true;
      let response = await Axios.get(
        BASE_API_URL + "broker/getBorrowersDocumentsDetails/" + this.loanTxnId);
      if (response.data.borrower.sendEmail) this.isMailSent = true;
      this.documents = response.data.documents.filter(
        doc => doc.categoryName != "Loan Estimate"
      );
      this.currentEnvironment = response.data.env;
      this.borrowerDetails = response.data.borrower;
      this.hasSubjectProperty = response.data.subjectProperty;
      /********************************************************** 
       *      Don't Remove this code 
      //To disable import 3.2 button if fnm is already uploaded
      // if (this.hasEdit()) {
      //   let button: any = document.getElementById("import");
      //   if (this.borrowerDetails.ediFile) button.disabled = true;
      // }
       **********************************************************/

      this.loanInformation = this.borrowerDetails.loanInformation;
      if (
        (this.borrowerDetails.source == null ||
          this.borrowerDetails.source == "wemlo") &&
        this.borrowerDetails.ediFile == null
      ) {
        this.hideSubmit = true;
      } else if (
        (this.borrowerDetails.source == "skipPricing" ||
          this.borrowerDetails.source == "otherLender") &&
        this.borrowerDetails.ediFile == null
      ) {
        this.hideSubmit = true;
        this.dashboardOnboarding = true;
      } else {
        this.hideSubmit = false;
      }
      /**
       * sprint 6
       */
      let inProgressLoan = this.checkLoanIsInProgress(
        response.data.borrower.activeLoanStatus
      );
      if (!inProgressLoan) {
        this.showButton = false;
      } else {
        this.showButton = true;
      }
      // this.moveToLead = response.data.borrower.moveToLead;
      this.setLoaderValues();
      this.$store.state.wemloLoader = false;
      this.areDocumentsLoaded = true;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }
  public conditionOfShowingButton() {
    if ((this.hasEdit() && !this.showButton) || this.moveToLead) {
      return true;
    } else return false;
  }
  public checkLoanIsInProgress(activeLoanStatus) {
    if (
      activeLoanStatus &&
      activeLoanStatus.statusId != 1 &&
      activeLoanStatus.statusId != 2 &&
      activeLoanStatus.statusId != 4
    )
      return true;
    else return false;
  }
  public setLoaderValues() {
    let docs = this.documents;
    docs.forEach((d, i) => {
      if (d.categoryType == "Income Documents") {
        this.loader1.push(false);
      }
      if (d.categoryType == "Assets") {
        this.loader2.push(false);
      }
      if (d.categoryType == "Property") {
        this.loader3.push(false);
      }
      if (d.categoryType == "Identification") {
        this.loader4.push(false);
      }
      if (d.categoryType == "Miscellaneous") {
        this.loader5.push(false);
      }
    });
  }

  public hasEdit() {
    return this.$route.query.edit ? true : false;
  }

  /**************************************************************************************************
   *                                   TOGGLE RADIO BUTTON                                          *
   **************************************************************************************************/

  public async toggleRadioButton(id, doc, status) {
    try {
      if (
        doc.categoryName != "Credit Card Authorization" &&
        doc.categoryName != "Mortgage Statement"
      ) {
        if (doc.categoryName == "Purchase Agreement") {
          if (doc.documentStatus != "Not Applicable") {
            if (status == "Not Applicable") {
              this.validateDoc.validatePropertyPurchaseDoc = false;
              await this.updateDocumentStatus(id, "Not Applicable");
            } else {
              if (doc.documentStatus == status) {
                if (
                  this.borrowerDetails.loanInformation.purpose &&
                  this.borrowerDetails.loanInformation.purpose.name ==
                    "Purchase"
                )
                  this.validateDoc.validatePropertyPurchaseDoc = true;
                await this.updateDocumentStatus(
                  id,
                  "Not Applicable For Borrower"
                );
              } else {
                if (
                  this.borrowerDetails.loanInformation.purpose &&
                  this.borrowerDetails.loanInformation.purpose.name ==
                    "Purchase"
                )
                  this.validateDoc.validatePropertyPurchaseDoc = false;
                await this.updateDocumentStatus(id, status);
              }
            }
          } else if (doc.documentStatus == "Not Applicable") {
            if (status != "Not Applicable") {
              await this.updateDocumentStatus(id, status);
              // if (this.callOnSubmitToLoan) {
              //   if (
              //     this.borrowerDetails.loanInformation.purpose &&
              //     this.borrowerDetails.loanInformation.purpose.name ==
              //       "Purchase"
              //   )
              //     this.validateDoc.validatePropertyPurchaseDoc = true;
              // }
            } else {
              await this.updateDocumentStatus(id, "Required");
              if (this.callOnSubmitToLoan) {
                if (
                  this.borrowerDetails.loanInformation.purpose &&
                  this.borrowerDetails.loanInformation.purpose.name ==
                    "Purchase"
                )
                  this.validateDoc.validatePropertyPurchaseDoc = true;
              }
            }
          } else {
            await this.updateDocumentStatus(id, status);
          }
        } else if (doc.documentStatus == "Required") {
          await this.updateDocumentStatus(id, status);
        } else if (doc.documentStatus == status) {
          await this.updateDocumentStatus(id, "Required");
        } else {
          await this.updateDocumentStatus(id, status);
        }
      } else {
        if (doc.categoryName == "Credit Card Authorization") {
          if (doc.documentStatus != "Not Applicable") {
            if (status == "Not Applicable") {
              this.validateDoc.validateCreditAuth = false;
              this.$modal.show("creditAuthorizationModel");
            } else {
              if (doc.documentStatus == status) {
                if (this.callOnSubmitToLoan)
                  this.validateDoc.validateCreditAuth = true;
                await this.updateDocumentStatus(
                  id,
                  "Not Applicable For Borrower"
                );
              } else {
                this.validateDoc.validateCreditAuth = false;
                await this.updateDocumentStatus(id, status);
              }
            }
          }
        } else if (doc.categoryName == "Mortgage Statement") {
          if (doc.documentStatus != "Not Applicable") {
            if (status == "Not Applicable") {
              this.source = doc.categoryName;
              this.validateDoc.validatePropertyMortStmt = false;
              this.$modal.show("mortgageStatementModal");
              // return;
            } else {
              if (doc.documentStatus == status) {
                if (
                  this.borrowerDetails.loanInformation.purpose &&
                  this.borrowerDetails.loanInformation.purpose.name ==
                    "Cash-Out-Refinance"
                )
                  this.validateDoc.validatePropertyMortStmt = true;
                if (this.hasSubjectProperty)
                  this.validateDoc.validatePropertyReoMortStmt = true;
                await this.updateDocumentStatus(
                  id,
                  "Not Applicable For Borrower"
                );
              } else {
                this.validateDoc.validatePropertyMortStmt = false;
                this.validateDoc.validatePropertyReoMortStmt = false;

                await this.updateDocumentStatus(id, status);
              }
            }
          }
        }
      }
      if (this.callOnSubmitToLoan) this.validateLoanNADocs();
    } catch (error) {
      console.log(error);
    }
  }
  /**********************************************************************************
   *                To Check Document is Applicable or not to upload                *
   **********************************************************************************/
  public validateLoanNADocs() {
    if (!this.borrowerDetails.loanInformation.purpose) {
      let propertyDoc = this.filterDocumentsByCategoryType(
        "Property",
        "uploaded"
      );
      let propertyNADoc = this.filterDocumentsByCategoryType(
        "Property",
        "NaDoc"
      );
      let propertyBorToUpDoc = this.filterDocumentsByCategoryType(
        "Property",
        "borToUpload"
      );
      if (
        propertyNADoc.length == 3 ||
        propertyBorToUpDoc.length == 3 ||
        propertyDoc.length >= 1
      )
        this.validateDoc.validatePropertyDoc = false;
      else this.validateDoc.validatePropertyDoc = true;
    }

    if (this.hasSubjectProperty) {
      let homeOwnerDoc = this.filterPropertyDocuments(
        "Home Owners Insurance",
        "uploaded"
      );
      let homeOwnerNADoc = this.filterPropertyDocuments(
        "Home Owners Insurance",
        "NaDoc"
      );
      let homeOwnerBorToUpDoc = this.filterPropertyDocuments(
        "Home Owners Insurance",
        "borToUpload"
      );
      if (
        homeOwnerDoc.length == 1 ||
        homeOwnerNADoc.length == 1 ||
        homeOwnerBorToUpDoc.length == 1
      ) {
        this.validateDoc.validateHomeOwnerDoc = false;
      } else this.validateDoc.validateHomeOwnerDoc = true;
    }

    if (this.hasSubjectProperty) {
      let propertyMortgageDoc = this.filterPropertyDocuments(
        "Mortgage Statement",
        "uploaded"
      );
      let mortgageNADoc = this.filterPropertyDocuments(
        "Mortgage Statement",
        "NaDoc"
      );
      let mortgageBorToUpDoc = this.filterPropertyDocuments(
        "Mortgage Statement",
        "borToUpload"
      );
      if (
        propertyMortgageDoc.length >= 1 ||
        mortgageNADoc.length == 1 ||
        mortgageBorToUpDoc.length == 1
      ) {
        // this.validateDoc.validatePropertyMortStmt = false;
        this.validateDoc.validatePropertyReoMortStmt = false;
      } else this.validateDoc.validatePropertyReoMortStmt = true;
      // this.validateDoc.validatePropertyMortStmt = true;
    }
    let assetsDoc = this.filterDocumentsByCategoryType("Assets", "uploaded");
    let assetsNADoc = this.filterDocumentsByCategoryType("Assets", "NaDoc");
    let assetBorToUpDoc = this.filterDocumentsByCategoryType(
      "Assets",
      "borToUpload"
    );

    if (
      assetsNADoc.length == 2 ||
      assetBorToUpDoc.length == 2 ||
      assetsDoc.length >= 1 ||
      (assetsNADoc.length == 1 && assetBorToUpDoc.length == 1)
    ) {
      this.validateDoc.validateAssetDoc = false;
    } else this.validateDoc.validateAssetDoc = true;

    let incomeDoc = this.filterDocumentsByCategoryType(
      "Income Documents",
      "uploaded"
    );
    let incomeNADoc = this.filterDocumentsByCategoryType(
      "Income Documents",
      "NaDoc"
    );
    let incomeBorToUpDoc = this.filterDocumentsByCategoryType(
      "Income Documents",
      "borToUpload"
    );
    this.incomeDocumentScenerioComparision(
      incomeDoc,
      incomeNADoc,
      incomeBorToUpDoc
    );

    this.validateDoc = JSON.parse(JSON.stringify(this.validateDoc));
  }

  public incomeDocumentScenerioComparision(
    incomeDoc,
    incomeNADoc,
    incomeBorToUpDoc
  ) {
    if (
      incomeDoc.length >= 2 ||
      incomeNADoc.length + incomeBorToUpDoc.length == 8 ||
      (incomeNADoc.length + incomeBorToUpDoc.length == 7 &&
        incomeDoc.length == 1)
    ) {
      this.countUploadedIncomeDoc = null;
    } else if (
      (incomeDoc.length == 0 &&
        incomeNADoc.length == 0 &&
        incomeBorToUpDoc.length == 0) ||
      (incomeDoc.length == 0 &&
        incomeBorToUpDoc.length + incomeNADoc.length <= 6)
    ) {
      this.countUploadedIncomeDoc = 2;
    } else if (
      incomeNADoc.length + incomeBorToUpDoc.length == 7 ||
      (incomeDoc.length == 1 &&
        incomeNADoc.length + incomeBorToUpDoc.length <= 6)
    )
      this.countUploadedIncomeDoc = 1;
  }

  public async saveMortgageComment() {
    try {
      if (this.comment == null) {
        this.errorComment = true;
        return;
      }
      this.errorComment = false;
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "pos/saveMortgageComment",
        {
          loanTxnId: this.loanTxnId,
          comment: this.comment,
          source: this.source
        });
      if (response.data == "success") {
        let doc = this.documents.filter(
          doc => doc.categoryName == "Mortgage Statement"
        );
        doc = doc[0];
        await this.updateDocumentStatus(doc._id, "Not Applicable");
        this.comment = null;
        this.$modal.hide("mortgageStatementModal");
        this.$snotify.success("Comment Saved Successfully");
      }
      if (this.callOnSubmitToLoan) this.validateLoanNADocs();
      this.$store.state.wemloLoader = false;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  openCommentModalForStatus(id, status) {
    this.docId = id;
    this.docStatus = status;
    this.$modal.show("docCommentModal");
  }

  public async updateDocumentStatus(id, status) {
    try {
      if (this.docStatus && !this.docComment) {
        this.errorInComment = true;
        return;
      }

      let response = await Axios.post(
        BASE_API_URL + "pos/updateLoanDocumentStatus",
        {
          id: id,
          status: status,
          loanTxnId: this.loanTxnId,
          comment: this.docComment
        });
      this.documents = response.data;
      this.docId = null;
      this.docStatus = null;
      this.docComment = null;
      this.$modal.hide("docCommentModal");
    } catch (error) {
      console.log(error);
    }
  }

  public categoryHasDocuments(catName) {
    let x = this.documents.filter(uploadedDoc => {
      if (
        uploadedDoc.categoryType == catName &&
        uploadedDoc.fileHistory.length > 0 &&
        uploadedDoc.fileHistory[uploadedDoc.fileHistory.length - 1].files
          .length > 0
      ) {
        return uploadedDoc;
      }
    });
    return x.length > 0 ? true : false;
  }

  public checkDocumentHasUploaded(doc) {
    let returnData = false;
    if (doc.documentStatus != "Not Applicable") {
      if (doc.fileHistory.length > 0) {
        if (doc.fileHistory[doc.fileHistory.length - 1].status == "Rejected") {
          returnData = true;
        } else returnData = false;
      } else {
        if (
          // doc.categoryName == "Credit Card Authorization" &&
          doc.documentStatus == "Wemlo Assitance"
        )
          returnData = false;
        else returnData = true;
      }
    }
    return returnData;
  }

  public checkDocumentHasApproved(doc) {
    let returnData = false;
    if (doc.documentStatus != "Not Applicable") {
      if (doc.fileHistory.length > 0) {
        if (doc.fileHistory[doc.fileHistory.length - 1].status == "Approved") {
          returnData = true;
        }
      } else {
        returnData = true;
      }
    }
    return returnData;
  }

  public fileExtension(fileName) {
    let ext = fileName.substr(fileName.lastIndexOf(".") + 1);
    return ext.toLowerCase();
  }

  public async setFIleToDisplay(action = null) {
    if (
      action == "next" &&
      this.displayingFileIndex < this.filesForSlide.length - 1
    ) {
      this.displayingFileIndex++;
    } else if (action == "previous" && this.displayingFileIndex > 0) {
      this.displayingFileIndex--;
    }
    if (this.displayingFileIndex >= this.filesForSlide.length) {
      this.displayingFileIndex--;
    }

    this.fileToDisplay =
      this.filesForSlide[this.displayingFileIndex];
    let ext = await this.fileExtension(this.fileToDisplay);
    this.displayFileType = ext.toLowerCase();
  }

  public async loadFilesForSlide(doc, conditionType, id) {
    let display = doc.fileHistory[doc.fileHistory.length - 1].files;
    let showDeleteButton = null;
    if (!this.checkFileHasRejectedOrApporoved(doc)) {
      showDeleteButton = true;
    } else {
      showDeleteButton = false;
    }
    this.$refs.dfl["setInitialValuesForShowingSamplesWithDeleteButton"](
      display,
      showDeleteButton,
      { docId: id },
      conditionType,
      "loanDocument"
    );
  }

  /**************************************************************************************************
   *              FOR DELETING THE FILES FROM FILE HISTORY (FILES)      don't remove                *
   **************************************************************************************************/
  // public async removeFile() {
  //   try {
  //     let file = this.filesForSlide[this.displayingFileIndex].path;
  //     let response = await Axios.post(
  //       BASE_API_URL + "pos/removeLoanDocumentFile",
  //       {
  //         loanTxnId: this.loanTxnId,
  //         id: this.displayingFileId,
  //         file: file,
  //         fileIndex: this.displayingFileIndex
  //       },
  //       {
  //
  //       }
  //     );
  //     this.confirmDeleteFile = false;
  //     this.documents = response.data;
  //     this.filesForSlide = this.filesForSlide.filter(
  //       (e, i) => e != file && i != this.displayingFileIndex
  //     );
  //     if (this.filesForSlide.length > 0) {
  //       this.setFIleToDisplay();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  public addNewSubcategory(category = null) {
    if (category) {
      this.newCategory = category;
      this.isCategoryFixed = true;
    }
    this.$modal.show("newCategoryModal");
  }

  public async insertNewCategoryAndSubcategory() {
    try {
      if (!this.newCategory || this.newCategory == null) {
        this.isNewCategoryEmpty = true;
        //this.$snotify.error('Please enter category type first');
        return;
      } else if (!this.newSubCategory || this.newSubCategory == null) {
        this.isNewSubCatEmpty = true;
        //this.$snotify.error('Please enter category name first');
        return;
      }
      let response = await Axios.post(
        BASE_API_URL + "pos/addNewDocumentCategory",
        {
          loanTxnId: this.loanTxnId,
          category: this.newCategory,
          subCategory: this.newSubCategory
        });
      this.documents = response.data;
      this.hideNewCategoryModal();
    } catch (error) {
      console.log(error);
    }
  }

  public hideNewCategoryModal() {
    this.$modal.hide("newCategoryModal");
    this.newCategory = null;
    this.newSubCategory = null;
    this.isCategoryFixed = false;
  }

  public async sendMailToSuperAdmin() {
    try {
      let response = await Axios.post(
        BASE_API_URL + "pos/sendMailToSuperAdmin",
        {
          loanTxnId: this.loanTxnId
        });
    } catch (error) {}
  }

  /**************************************************************************************************
   *                                    IF DOCUMENT NOT LOADED THEN                                  *
   **************************************************************************************************/
  public ifDocumentNotLoad(time: number) {
    try {
      setTimeout(() => {
        let checkLoader = document.getElementById("checkLoader");
        if (checkLoader != null) {
          let iframe: any = document.getElementById("checkElement");
          if (iframe.localName == "iframe") {
            iframe.src =
              "https://docs.google.com/gview?url=" +
              this.fileToDisplay +
              "&embedded=true";
          } else {
            iframe.src = this.fileToDisplay;
          }
          this.ifDocumentNotLoad(time + 1000);
        }
      }, time);
    } catch (error) {
      console.log(error);
    }
  }

  // public downloadFile(file) {
  //   window.open(file);
  // }

  /**************************************************************************************************
   *                                       TO SHOW THREE THE FILE HISTORY                            *
   **************************************************************************************************/
  public showThreeFileHistory(fileHistory) {
    let length = fileHistory.length;
    if (length > 3) {
      return fileHistory.slice(length - 3, length);
    }
    return fileHistory;
  }

  /*****************************************************************************************************
   *              filter Documents Based on CategoryType                                               *
   *****************************************************************************************************/
  public filterDocumentsByCategoryType(categoryType, type) {
    if (type == "uploaded") {
      let uploadedDoc = this.documents.filter(
        doc => doc.categoryType == categoryType && doc.fileHistory.length > 0
      );
      return uploadedDoc;
    } else if (type == "borToUpload") {
      let borToUpload = this.documents.filter(
        doc =>
          doc.categoryType == categoryType &&
          doc.documentStatus == "Wemlo Assitance" &&
          doc.fileHistory.length == 0
      );
      return borToUpload;
    } else {
      let NADoc = this.documents.filter(
        doc =>
          doc.categoryType == categoryType &&
          doc.documentStatus == "Not Applicable" &&
          doc.fileHistory.length == 0
      );
      return NADoc;
    }
  }

  /*****************************************************************************************************
   *                filter property Documents Based on CategoryName                                    *
   *****************************************************************************************************/
  public filterPropertyDocuments(categoryName, type) {
    if (type == "uploaded") {
      let uploadedDoc = this.documents.filter(
        doc =>
          doc.categoryType == "Property" &&
          doc.categoryName == categoryName &&
          doc.fileHistory.length > 0 &&
          doc.documentStatus != "Not Applicable"
      );
      return uploadedDoc;
    } else if (type == "borToUpload") {
      let borToUpload = this.documents.filter(
        doc =>
          doc.categoryType == "Property" &&
          doc.categoryName == categoryName &&
          doc.documentStatus == "Not Applicable" &&
          doc.fileHistory.length == 0
      );
      return borToUpload;
    } else {
      let NaDoc = this.documents.filter(
        doc =>
          doc.categoryType == "Property" &&
          doc.categoryName == categoryName &&
          doc.documentStatus == "Wemlo Assitance" &&
          doc.fileHistory.length == 0
      );
      return NaDoc;
    }
  }

  /********************************************************************************************
   *               TO VALIDATE LOAN DOCUMENTS                                                 *
   ********************************************************************************************/

  public validateLoanDocuments(documents) {
    let showError = false;
    let incomeDoc = this.filterDocumentsByCategoryType(
      "Income Documents",
      "uploaded"
    );
    let incomeNADoc = this.filterDocumentsByCategoryType(
      "Income Documents",
      "NaDoc"
    );
    let incomeBorToUpDoc = this.filterDocumentsByCategoryType(
      "Income Documents",
      "borToUpload"
    );

    this.incomeDocumentScenerioComparision(
      incomeDoc,
      incomeNADoc,
      incomeBorToUpDoc
    );
    let assetDoc = this.filterDocumentsByCategoryType("Assets", "uploaded");
    let assetsNADoc = this.filterDocumentsByCategoryType("Assets", "NaDoc");
    let assetBorToUpDoc = this.filterDocumentsByCategoryType(
      "Assets",
      "borToUpload"
    );
    if (
      assetDoc.length >= 1 ||
      assetsNADoc.length == 2 ||
      assetBorToUpDoc.length == 2 ||
      (assetsNADoc.length == 1 && assetBorToUpDoc.length == 1)
    )
      this.validateDoc.validateAssetDoc = false;
    else this.validateDoc.validateAssetDoc = true;

    let identificationDoc = documents.filter(
      doc =>
        doc.categoryType == "Identification" &&
        (doc.documentStatus == "Not Applicable" ||
          doc.documentStatus == "Wemlo Assitance") &&
        doc.categoryName == "Credit Card Authorization"
    );
    let idDoc = documents.filter(
      doc =>
        doc.categoryName == "Credit Card Authorization" &&
        doc.documentStatus != "Not Applicable" &&
        doc.fileHistory.length > 0
    );
    if (identificationDoc.length == 1 || idDoc.length == 1)
      this.validateDoc.validateCreditAuth = false;
    else this.validateDoc.validateCreditAuth = true;

    if (this.hasSubjectProperty) {
      let homeOwnerDoc = this.filterPropertyDocuments(
        "Home Owners Insurance",
        "uploaded"
      );
      let homeOwnerNADoc = this.filterPropertyDocuments(
        "Home Owners Insurance",
        "NaDoc"
      );
      let homeOwnerBorToUpDoc = this.filterPropertyDocuments(
        "Home Owners Insurance",
        "borToUpload"
      );

      if (
        homeOwnerDoc.length == 1 ||
        homeOwnerNADoc.length == 1 ||
        homeOwnerBorToUpDoc.length == 1
      ) {
        this.validateDoc.validateHomeOwnerDoc = false;
      } else this.validateDoc.validateHomeOwnerDoc = true;
    }
    if (this.borrowerDetails.loanInformation.purpose) {
      if (this.borrowerDetails.loanInformation.purpose.name == "Purchase") {
        let propertyPurchaseDoc = this.filterPropertyDocuments(
          "Purchase Agreement",
          "uploaded"
        );
        let puchaseNaDoc = this.filterPropertyDocuments(
          "Purchase Agreement",
          "NaDoc"
        );
        let purchaseBorToUpDoc = this.filterPropertyDocuments(
          "Purchase Agreement",
          "borToUpload"
        );
        if (
          propertyPurchaseDoc.length >= 1 ||
          puchaseNaDoc.length == 1 ||
          purchaseBorToUpDoc.length == 1
        ) {
          this.validateDoc.validatePropertyPurchaseDoc = false;
        } else this.validateDoc.validatePropertyPurchaseDoc = true;

        if (this.hasSubjectProperty) {
          let propertyMortgageDoc = this.filterPropertyDocuments(
            "Mortgage Statement",
            "uploaded"
          );
          let mortgageNADoc = this.filterPropertyDocuments(
            "Mortgage Statement",
            "NaDoc"
          );
          let mortgageBorToUpDoc = this.filterPropertyDocuments(
            "Mortgage Statement",
            "borToUpload"
          );
          if (
            propertyMortgageDoc.length >= 1 ||
            mortgageNADoc.length == 1 ||
            mortgageBorToUpDoc.length == 1
          ) {
            this.validateDoc.validatePropertyReoMortStmt = false;
          } else this.validateDoc.validatePropertyReoMortStmt = true;
        }
      } else {
        let propertyMortgageDoc = this.filterPropertyDocuments(
          "Mortgage Statement",
          "uploaded"
        );
        let mortgageNADoc = this.filterPropertyDocuments(
          "Mortgage Statement",
          "NaDoc"
        );
        let mortgageBorToUpDoc = this.filterPropertyDocuments(
          "Mortgage Statement",
          "borToUpload"
        );
        if (
          propertyMortgageDoc.length >= 1 ||
          mortgageNADoc.length == 1 ||
          mortgageBorToUpDoc.length == 1
        ) {
          this.validateDoc.validatePropertyReoMortStmt = false;
        } else this.validateDoc.validatePropertyReoMortStmt = true;
      }
    } else {
      let propertyDoc = this.filterDocumentsByCategoryType(
        "Property",
        "uploaded"
      );
      let propertyNADoc = this.filterDocumentsByCategoryType(
        "Property",
        "NaDoc"
      );
      let propertyBorToUpload = this.filterDocumentsByCategoryType(
        "Property",
        "borToUpload"
      );
      if (
        propertyDoc.length >= 1 ||
        propertyNADoc.length == 3 ||
        propertyBorToUpload.length == 3
      )
        this.validateDoc.validatePropertyDoc = false;
      else this.validateDoc.validatePropertyDoc = true;
    }

    if (
      this.countUploadedIncomeDoc == 1 ||
      this.countUploadedIncomeDoc == 2 ||
      this.validateDoc.validateAssetDoc ||
      this.validateDoc.validatePropertyPurchaseDoc ||
      this.validateDoc.validatePropertyMortStmt ||
      this.validateDoc.validateCreditAuth ||
      this.validateDoc.validatePropertyDoc ||
      this.validateDoc.validateHomeOwnerDoc
    ) {
      this.validateDoc = JSON.parse(JSON.stringify(this.validateDoc));
      showError = true;
    }
    return showError;
  }

  public removeValidation() {
    try {
      this.countUploadedIncomeDoc = null;
      this.validateDoc = {};
    } catch (error) {
      console.log(error);
    }
  }
  /**********************************************************************
   *        TO CLOSE MORTGAGE STATEMENT MODAL                           *
   **********************************************************************/

  public closeMortgageStatementModal() {
    if (this.borrowerDetails.loanInformation.purpose) {
      if (
        this.borrowerDetails.loanInformation.purpose.name ==
          "Cash-Out Refinance" ||
        this.borrowerDetails.loanInformation.purpose.name ==
          "R/T Refi (Limited Cash-Out)" ||
        this.hasSubjectProperty
      ) {
        let propertyDoc = this.documents.filter(
          doc =>
            doc.categoryType == "Property" &&
            doc.categoryName == "Mortgage Statement" &&
            doc.documentStatus == "Not Applicable" &&
            doc.fileHistory.length == 0
        );
        if (propertyDoc.length == 1) {
          this.validateDoc.validatePropertyMortStmt = false;
        } else this.validateDoc.validatePropertyMortStmt = true;
      }
    }
    this.$modal.hide("mortgageStatementModal");
    this.comment = null;
    this.docFiles = null;
    this.errorComment = null;
    this.docComment = null;
    this.docStatus = null;
  }

  /****************************************************************************************
   *            Checking required field in 1003 form                                      *
   *                                                                                      *
   ****************************************************************************************/
  public async checkLosFormCompleted() {
    try {
      let response = await Axios.post(
        BASE_API_URL + "loan/checkLosFormCompleted",
        { loanTxnId: this.loanTxnId });
      if (response.data.status == "error") {
        return response.data.errorList;
      }
    } catch (error) {
      console.log(error);
    }
  }
  get isSubmitBtnDisabled() {
    return !this.areDocumentsLoaded || this.warningClearedToSubmit;
  }
  /**
   * If Save Lead is clicked then we are saving the status Prospect
   */
  public async submitToWemlo(type) {
    try {
      let valid = await this.$validator.validateAll();
      let body = null;
      if (type == "saveLead") {
        if (!valid) {
          return;
        }
        body = {
          loanTxnId: this.loanTxnId,
          loanInformation: this.loanInformation,
          type: type
        };
      } else {
        let documents = this.documents;
        this.callOnSubmitToLoan = true;
        let hasDocumentLeftToUpload = this.validateLoanDocuments(documents);
        if (hasDocumentLeftToUpload) {
          this.showDocumentPopup();
        }
        if (hasDocumentLeftToUpload || !valid) return;
        if (this.$route.query.edit) {
          let validLoanAmount = await this.$refs.amount["validateAll"]();
          let validInterestRate = await this.$refs.rate["validateAll"]();
          let validPrice = await this.$refs.price["validateAll"]();
          if (
            !validLoanAmount ||
            !validInterestRate ||
            !validPrice ||
            this.hasLessThanLoanAmount ||
            this.hasGreaterRate
          )
            return;
        }

        // this.losRequiredList = await this.checkLosFormCompleted();
        // if (this.losRequiredList) {
        //   this.isLosFieldMissing = true;
        //   return;
        // }
        body = {
          loanTxnId: this.loanTxnId,
          userType: this.$userType,
          type: type,
          brokerId: this.$brokerId,
          loanInformation: this.loanInformation
        };
      }
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "broker/saveLoanStatus",
        body);
      this.$store.state.wemloLoader = false;
      if (type == "submit") {
        this.losRequiredList = await this.checkLosFormCompleted();
        if (this.losRequiredList) {
          this.isLosFieldMissing = true;
          return;
        }
      }
      if (this.moveToLead) {
        this.updateMoveToLead();
        return;
      }
      if (!this.moveToLead) {
        if (response.data.message == "saveLead") {
          if (!this.hasEdit()) {
            this.$router.push({
              path: this.$getCurrentUserTypePath("blank-backGround-popUp"),
              query: {
                id: this.$route.query.id,
                modalName: "savelead",
                source: "Documents Upload & Request "
              }
            });
          } else {
            this.$router.push("/dashboard");
          }
        } else if (response.data.message == "Success") {
          // Check Sbmit to Wemlo Button Have Enable Or Not 
          let isActiveSubmitToWemlo = await this.checkSubmitToWemloButtonHaveActive();
          if(!isActiveSubmitToWemlo){
            this.$modal.show('SubmitToWemloWarningCountDownModal');
            return;
          }
          this.$router.push({
            path: this.$getCurrentUserTypePath("submission-form"),
            query: { id: this.loanTxnId, edit: "true" }
          });
        }
      }
      // this.sendMailToSuperAdmin();
      this.$store.state.wemloLoader = false;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }
  // To change the status of moveToLead when clicked on the button MoveToLead on processor side
  //so that after inprocessing loan can move to leads
  public async updateMoveToLead() {
    try {
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "broker/updateMoveToLead",
        {
          loanTxnId: this.loanTxnId,
          moveToLead: this.moveToLead,
          userType: this.$userType
        });
      this.$store.state.wemloLoader = false;
      this.$snotify.success("Data Saved Successfully");
      this.$router.push("/dashboard");
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  public async checkApprisalOrdered(taskOption) {
    let formValid = await this.$validator.validateAll();
    if (!this.comment) {
      this.errorComment = true;
      return;
    }
    if (!formValid) {
      if (!this.hasAppraisal) return;
    }
    if (
      taskOption == "appraisalWaiver" ||
      taskOption == "appraisalExcemption"
    ) {
      this.$modal.hide("creditAuthorizationModel");
      this.$modal.show("appraisalOrderTask");
    } else if (taskOption == "appraisalOrdered") {
      await this.submitCreditAuthorization();
    }
  }

  /**************************************************************************************************
   *                         ON MARKING AS NA TO CREDIT AUTHORIZATION                               *
   **************************************************************************************************/
  public async submitCreditAuthorization() {
    try {
      this.isSubmit = true;
      let body = {
        loanTxnId: this.loanTxnId,
        taskOption: this.taskOption,
        notVoeNumber: this.notVoeNumber,
        comment: this.comment
      };
      this.errorComment = false;
      let response = await Axios.post(
        BASE_API_URL + "additionalTask/submitCreditAuthorization",
        body);
      this.isSubmit = false;
      if (response.data == "Success") {
        let doc = this.documents.filter(
          d => d.categoryName == "Credit Card Authorization"
        );
        doc = doc[0];
        this.comment = null;
        await this.updateDocumentStatus(doc._id, "Not Applicable");
        this.$modal.hide("creditAuthorizationModel");
        this.$snotify.success("Data saved successfully");
        await this.getBorrowersDocumentsDetails();
        if (this.callOnSubmitToLoan) this.validateLoanNADocs();
      }
      this.$modal.hide("appraisalOrderTask");
    } catch (error) {
      this.isSubmit = false;
      console.log(error);
    }
  }

  public dragFile(e, docId) {
    let droppedDocuments = e.dataTransfer.files;
    if (!droppedDocuments) {
      return;
    }
    let documentExtension: any = this.getDocumentExtension(droppedDocuments);
    this.checkDocumentExt = true;
    documentExtension.forEach(e => {
      this.docExtension.forEach((element, i) => {
        if (e == element.fileExt) {
          this.checkDocumentExt = false;
        }
      });
    });
    if (this.checkDocumentExt) {
      this.$modal.show("validationErrorMsgModal");
      return;
    }
    this.uploadFile("skip", droppedDocuments, docId);
  }

  public attachFile(event, docId) {
    if (event.target.files.length == 0) {
      return;
    }
    let docFiles = event.target.files;
    let documentExtension: any = this.getDocumentExtension(docFiles);
    this.checkDocumentExt = true;
    documentExtension.forEach(e => {
      this.docExtension.forEach((element, i) => {
        if (e == element.fileExt) {
          this.checkDocumentExt = false;
        }
      });
    });
    if (this.checkDocumentExt) {
      this.$modal.show("validationErrorMsgModal");
      return;
    }
    this.uploadFile("skip", docFiles, docId);
  }

  /**
   *  Function to automate file upload for local dev testing
   */

  public async automateFileUploadForDev(event){
    let docFiles =  event.target.files;
    let allDocuments = this.documents.map(doc => {return doc._id})
     allDocuments.forEach(docId => {
         if(docId) this.uploadFile("skip", docFiles, docId);
     });

     //ACCNT NO UPDATE FOR MISSING ASSET
    //  let accntNoSavePayload = {"loanTxnId":this.loanTxnId,"assetsInfoDetails":[{"accountType":{"name":"Cash Deposit On Sale Contract","ediValue":"F1","mismoValue":"CashDepositOnSaleContract","value":"Cash Deposit On Sale Contract"},"financialInstitution":"ABC Realty","accountNumber":"123456","stockAndBondsDecription":null,"_id":"5f40bd606899b951731db4d1","borrowerIndex":0,"address":{"street":"3700 Connecticut St","city":"Burbank","state":{"code":"CA","name":"California"},"zip":"91502","county":"Los Angeles County","country":"United States"},"cashOrMarketValue":10000,"assetsMapping":[{"_id":"5f40bd606899b951731db4d2","borrowerIndex":0,"jointStatus":true}]},{"accountType":{"name":"Checking","ediValue":"03","mismoValue":"CheckingAccount","value":"Checking"},"financialInstitution":"Bank of Noosh","accountNumber":"123456","stockAndBondsDecription":null,"_id":"5f40bd606899b951731db4cf","borrowerIndex":0,"address":{"street":"15096 Sunnyside St","city":"Burbank","state":{"code":"CA","name":"California"},"zip":"91502","county":"Los Angeles County","country":"United States"},"cashOrMarketValue":12000,"assetsMapping":[{"_id":"5f40bd606899b951731db4d0","borrowerIndex":0,"jointStatus":true}]},{"accountType":{"name":"Certificate of Deposit(CD Account)","ediValue":"01","mismoValue":"CertificateOfDepositTimeDeposit","value":"Certificate of Deposit"},"financialInstitution":"Bank of Noosh","accountNumber":"1234567","stockAndBondsDecription":null,"_id":"5f40bd606899b951731db4cd","borrowerIndex":0,"address":{"street":"15096 Sunnyside St","city":"Burbank","state":{"code":"CA","name":"California"},"zip":"91502","county":"Los Angeles County","country":"United States"},"cashOrMarketValue":100000,"assetsMapping":[{"_id":"5f40bd606899b951731db4ce","borrowerIndex":0,"jointStatus":true}]},{"accountType":{"name":"Trust Account","ediValue":"11","mismoValue":"TrustAccount","value":"Trust Account"},"financialInstitution":"Fidelity Investments","accountNumber":"6465456","stockAndBondsDecription":null,"_id":"5f40bd606899b951731db4cb","borrowerIndex":0,"address":{"street":"1234 Wall St","city":"New York","state":{"code":"NY","name":"New York"},"zip":"01016","county":null,"country":null},"cashOrMarketValue":50000,"assetsMapping":[{"_id":"5f40bd606899b951731db4cc","borrowerIndex":0,"jointStatus":true}]},{"accountType":{"name":"Mutual Fund","ediValue":"F4","mismoValue":"MutualFund","value":"Mutual Fund"},"financialInstitution":"UBS","accountNumber":"55555","stockAndBondsDecription":null,"_id":"5f40bd606899b951731db4c9","borrowerIndex":0,"address":{"street":"111 Wall St","city":"New York","state":{"code":"NY","name":"New York"},"zip":"01016","county":null,"country":null},"cashOrMarketValue":120000,"assetsMapping":[{"_id":"5f40bd606899b951731db4ca","borrowerIndex":0,"jointStatus":true}]}]}
    //   await Axios.post(
    //     BASE_API_URL + "los/saveAssetsData",
    //     accntNoSavePayload,
    //     {
    //
    //     }
    //   );
  }

  public getDocumentExtension(file) {
    let documentExtension = [];
    let documentName = [];
    Object.values(file).forEach((e: any) => {
      documentName.push(e.name);
    });
    documentName.forEach(name => {
      if (name.lastIndexOf(".") != 0) {
        documentExtension.push(name.substring(name.lastIndexOf(".") + 1));
      }
    });
    return documentExtension;
  }

  public async uploadFile(action, files, id) {
    try {
      this.docFiles = files;
      this.docId = id;
      if (this.docFiles.length == 0) {
        return;
      }
      this.$store.state.wemloLoader = true;
      let formData = new FormData();
      Object.keys(this.docFiles).forEach((e, i) => {
        formData.append("file", this.docFiles[i]);
      });
      formData.append("id", this.docId);
      formData.append("loanTxnId", this.loanTxnId);
      formData.append("userId", this.$userId);
      formData.append("action", action);
      let response = await Axios.post(
        BASE_API_URL + "pos/uploadLoanDocument",
        formData);
      this.documents = response.data;
      this.validateLoanDocuments(this.documents);
      this.checkDocHasUploaded = false;
      this.docFiles = [];
      this.docId = null;
      this.docComment = null;
      this.checkDocumentExt = false;
      this.$snotify.success("file uploaded successfully");
      this.$store.state.wemloLoader = false;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  public checkFileHasRejectedOrApporoved(doc) {
    let returnStatus = false;
    if (doc.documentStatus != "Not Applicable") {
      if (
        doc.fileHistory.length > 0 &&
        (doc.fileHistory[doc.fileHistory.length - 1].status == "Rejected" ||
          doc.fileHistory[doc.fileHistory.length - 1].status == "Approved")
      ) {
        returnStatus = true;
      }
    }
    return returnStatus;
  }

  public openConfirmationModal(fileHistory, subCategory, id) {
    this.displayingFileSubCategoryName = subCategory;
    this.documentId = id;
    this.$modal.show("confirmDeleteFileModal");
  }

  public deleteDocumentData() {
    this.isDelete = true;
    let body = {
      loanTxnId: this.loanTxnId,
      identifier: "deleteDocument",
      id: this.documentId
    };
    return body;
  }

  public deleteFileData(from) {
    let index = 0;
    let documents = this.documents;
    let doc = documents.filter(e => e._id == from.deleteData.docId);
    doc[0].fileHistory[doc[0].fileHistory.length - 1].files.forEach(
      (file, i) => {
        if (file.path == from.files) {
          index = i;
        }
      }
    );
    let file = from.files;
    let body = {
      loanTxnId: this.loanTxnId,
      id: from.deleteData.docId,
      file: file,
      fileIndex: index,
      identifier: "deleteFile"
    };
    return body;
  }

  public async deleteFile(from) {
    try {
      let body = null;
      if (from != null) body = this.deleteFileData(from);
      else body = this.deleteDocumentData();

      let response = await Axios.post(
        BASE_API_URL + "pos/removeLoanDocumentFile",
        body);
      if (response.data.identifier == "deleteDocument") {
        this.$modal.hide("confirmDeleteFileModal");
        this.$snotify.success("Document deleted successfully");
        this.isDelete = false;
      }
      this.documents = response.data.data;
      if (this.callOnSubmitToLoan) this.validateLoanDocuments(this.documents);
    } catch (error) {
      this.isDelete = false;
      console.log(error);
    }
  }

  public closeCreditAuthModal() {
    let identificationDoc = this.documents.filter(
      doc =>
        doc.categoryType == "Identification" &&
        (doc.documentStatus == "Not Applicable" ||
          doc.documentStatus == "Wemlo Assitance") &&
        doc.categoryName == "Credit Card Authorization"
    );
    if (this.callOnSubmitToLoan) {
      if (identificationDoc.length == 1)
        this.validateDoc.validateCreditAuth = false;
      else this.validateDoc.validateCreditAuth = true;
    }
    this.$modal.hide("creditAuthorizationModel");
    this.comment = null;
    this.docFiles = null;
    this.taskOption = null;
    this.errorComment = false;
    this.docComment = null;
    this.docStatus = null;
  }

  public async calculator() {
    this.hasLessThanLoanAmount =
      this.loanInformation.propertyValue < this.loanInformation.loanAmount
        ? true
        : false;
    this.hasGreaterRate =
      this.loanInformation.interestRate > 100 ? true : false;
    if (this.hasLessThanLoanAmount || this.hasGreaterRate) return;
    let interestRate = this.loanInformation.interestRate;
    let loanAmount: any = parseFloat(this.loanInformation.loanAmount);
    let termMonth = this.loanInformation.term
      ? this.loanInformation.term.value
      : null;
    if (
      this.loanInformation.productType &&
      (this.loanInformation.productType.ediValue == "03" ||
        this.loanInformation.productType.ediValue == "02")
    ) {
      let data = {
        mortgageAppliedFor: this.loanInformation.productType,
        purchasePrice: this.loanInformation.propertyValue,
        loanAmount: this.loanInformation.loanAmount,
        loanPurpose: this.loanInformation.purpose,
        veteranStatus: this.loanInformation.veteranStatus,
        purposeOfRefinance: this.loanInformation.refinanceCase.purposeOfRefinance
      };
      let fundingFeeData: any = this.calculateFundingFee(data);
      if (fundingFeeData && fundingFeeData.fundingFee)
        loanAmount =
          parseFloat(loanAmount) + parseFloat(fundingFeeData.fundingFee);
    }
    let dpt = this.loanInformation.minDownPaymentType;
    let pv: any = parseFloat(this.loanInformation.propertyValue);
    let la: any = parseFloat(this.loanInformation.loanAmount);
    let monthlyPayment: any = 0;
    if (interestRate && loanAmount && termMonth) {
      interestRate = interestRate / 100 / 12;
      let newInterest = interestRate + 1;
      let numerator = Math.pow(newInterest, termMonth);
      let newValue = (numerator * interestRate) / (numerator - 1);
      let calculateValue = newValue * loanAmount;
      monthlyPayment = Math.round(calculateValue * 100) / 100;
    }
    if (dpt == "$") {
      this.loanInformation.minDownPayment = pv - la;
    } else {
      this.loanInformation.minDownPayment = ((pv - la) / pv) * 100;
    }
    this.loanInformation.mortgageMonthlyPayment = monthlyPayment;
    this.calculateLTVAndCLTV();
  }

  public calculateLTVAndCLTV() {
    let propertyValue = this.loanInformation.propertyValue;
    let loanAmount = this.loanInformation.loanAmount;
    if (propertyValue && loanAmount && loanAmount <= propertyValue) {
      this.loanInformation.LTV = Math.round((loanAmount / propertyValue) * 100);
      this.loanInformation.LTV = this.loanInformation.LTV.toFixed(2);
    } else this.loanInformation.CLTV = this.loanInformation.LTV = 0;
  }

  public async showDtiAndHousingRatioDetails() {
    this.$store.state.wemloLoader = true;
    try {
      let response = await Axios.post(
        BASE_API_URL + "los/getlosHeaderData",
        {
          loanTxnId: this.loanTxnId
        }
      );
      
      if (response.status == 200) {
        this.dtiAndHousingRatioDetails = response.data;
      }

      this.ShowDtiValue = true;
    } catch (error) {
      console.log(error);
    }
    this.$store.state.wemloLoader = false;
  }

  /********************************************************************************************************************************
   *    This Function used for set calculation values in LOS.
   */
  public async LosCommonFunction() {
    try {
      let response = await Axios.post(
        BASE_API_URL + "los/callAllLOSCommonFunction",
        { loanTxnId: this.loanTxnId });
    } catch (error) {
      console.log(error);
    }
  }

  // public  modalForDtiRatio(){
  //   try {
  //     this.$modal.show("modalForDtiRatio")
  //   } catch (error) {
  //     console.log(error);

  //   }
  // }
  /********************************************************************************
   *         Don't Remove Commented code it can be further use for POS            *
 
  // public selectPosBorrower() {
  //   if (this.borrowerData && this.borrowerDetails) {
  //     if (this.borrowerDetails.relationshipMapping.length == 1) {
  //       this.$router.push({
  //         path: this.$getCurrentUserTypePath("pos-questionnaire"),
  //         query: {
  //           loanTxnId: this.loanTxnId,
  //           borrowerId: this.borrowerData.borrowerInfo[
  //             this.borrowerDetails.relationshipMapping[0].borrowerIndex
  //           ].userId
  //         }
  //       });
  //     } else {
  //       this.openBorrowerSelectionModal = true;
  //     }
  //   }
  // }
  ********************************************************************************/
public documentLeftToUpload = [];
  public async showDocumentPopup() {
    try {
      this.documentLeftToUpload = this.documents.filter(
        d => d.documentStatus == "Required"
      );
      this.$modal.show("showLeftDocuments");
    } catch (error) {
      console.log(error);
    }
  }
   public checkCategoryHasDoc(categoryType) {
    let docs = this.documentLeftToUpload.filter(
      doc => doc.categoryType == categoryType
    );
    return docs.length > 0 ? true : false;
  }

  public async getSettingMandatoryBrokerOnboarding(){
    try{
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "broker/getWemloSettingDetails",
        {
          userId: this.$userId,
        });
        if(response.status == 200) {
          this.isMandatoryBrokerOnboarding = response.data.statusMandatoryBrokerOnboarding || false;
        }
    }catch(error){
      console.log(error);
    }
    this.$store.state.wemloLoader = false;
  }

  async mounted() {
    this.loanTxnId = this.$route.query.id;
    this.LosCommonFunction();
    await this.fetchBorrwoerInfo();
    await this.getBorrowersDocumentsDetails();
    await this.getSettingMandatoryBrokerOnboarding();
    this.calculator();
    this.getBrokerDetails();
  }
}
